"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmProvider = exports.LlmDecisionModel = exports.LlmModel = void 0;
var LlmModel;
(function (LlmModel) {
    LlmModel["ClaudeOpus55"] = "claude-opus-5-5";
    LlmModel["ClaudeOpus5"] = "claude-opus-5";
    LlmModel["ClaudeSonnet5"] = "claude-sonnet-5";
    LlmModel["ClaudeHaiku45"] = "claude-haiku-4-5";
    LlmModel["Gpt51"] = "gpt-5.1";
    LlmModel["Gpt4oMini"] = "gpt-4o-mini";
})(LlmModel || (exports.LlmModel = LlmModel = {}));
// Decision models answer typed questions (choice, boolean, score) with probabilities instead of generating text.
var LlmDecisionModel;
(function (LlmDecisionModel) {
    LlmDecisionModel["Gpt6Luna"] = "gpt-6-luna";
})(LlmDecisionModel || (exports.LlmDecisionModel = LlmDecisionModel = {}));
var LlmProvider;
(function (LlmProvider) {
    LlmProvider["Anthropic"] = "anthropic";
    LlmProvider["OpenAi"] = "openai";
})(LlmProvider || (exports.LlmProvider = LlmProvider = {}));
